import { useQuery } from "react-query";
import ChartSerie from "../models/interfaces/dtos/chart-serie-dto";
import ENDPOINTS from "../services/endpoints.ts";
import {fetchItem} from "../queries/queries-helper.ts";

const useChartData = (localisationId: number, startDate: Date, endDate: Date, dataOption: string) => {
    const isoStartDate = startDate.toISOString();
    const isoEndDate = endDate.toISOString();

    let uri: string;
    if (dataOption === "SHAB" || dataOption === "SHO"){
        uri = ENDPOINTS.SURFACE_PROCESSED_PER_PHASE(localisationId, isoStartDate, isoEndDate, dataOption);
    }
    else if (dataOption === "revision_treegram") {
        uri = ENDPOINTS.SOURCE_REVISION_PER_PHASE(localisationId, isoStartDate, isoEndDate);
    }
    else {
        uri = ENDPOINTS.REVISION_BIMSYNC(localisationId, isoStartDate, isoEndDate);
    }

    return useQuery<ChartSerie[]>(
        ["chart-data", localisationId, isoStartDate, isoEndDate, dataOption],
        async () => {
            const data = await fetchItem<ChartSerie[]>(uri);
            return data ?? [];
        },
        {
            enabled: !!localisationId && !!startDate && !!endDate && !!dataOption,
            staleTime: 60 * 60 * 1000 // 1 heure
        }
    );
};

export default useChartData;
